import api from "../services/authService";

const appendMany = (params, key, values = []) => {
  values.filter(Boolean).forEach((value) => params.append(key, value));
};

export const fetchBriefBankEntries = async ({
  page = 1,
  pageSize = 25,
  query = "",
  practiceArea = "",
  briefTypes = [],
  conditionIssueTags = [],
  legalIssueTags = [],
  caseTags = [],
  filedAfter = "",
  filedBefore = "",
  finalOnly = true,
  sort = "",
} = {}) => {
  const params = new URLSearchParams({
    page: String(page),
    page_size: String(pageSize),
    final_only: finalOnly ? "true" : "false",
  });
  if (query) params.set("q", query);
  if (practiceArea) params.set("practice_area", practiceArea);
  if (filedAfter) params.set("filed_after", filedAfter);
  if (filedBefore) params.set("filed_before", filedBefore);
  if (sort) params.set("sort", sort);
  appendMany(params, "brief_type", briefTypes);
  appendMany(params, "condition_issue_tag", conditionIssueTags);
  appendMany(params, "legal_issue_tag", legalIssueTags);
  appendMany(params, "case_tag", caseTags);
  return api.get(`/brief-bank/entries/?${params.toString()}`);
};

export const fetchBriefBankFacets = async ({ finalOnly = true } = {}) =>
  api.get(`/brief-bank/facets/?final_only=${finalOnly ? "true" : "false"}`);

export const fetchBriefBankEntry = async (entryId) =>
  api.get(`/brief-bank/entries/${entryId}/`);

export const fetchBriefBankPreviewUrl = async (documentId, config = {}) =>
  api.get(`/documents/presigned-url/${documentId}/`, config);

export const fetchBriefBankPreview = async (entryId, config = {}) =>
  api.get(`/brief-bank/entries/${entryId}/preview/`, {
    ...config,
    responseType: "blob",
  });

export const uploadBriefBankEntry = async (formData) =>
  api.post("/brief-bank/upload/", formData, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 180000,
  });

export const addDocumentToBriefBank = async (documentId, payload) =>
  api.post(`/brief-bank/documents/${documentId}/add/`, payload);

export const copyBriefBankEntry = async (entryId, payload) =>
  api.post(`/brief-bank/entries/${entryId}/copy/`, payload);

export const searchBriefBankMatters = async (query) =>
  api.get(`/matters/?search=${encodeURIComponent(query)}&page_size=10`);

export const fetchBriefBankMatterFolders = async (matterId) =>
  api.get(
    `/folders/?matter_id=${encodeURIComponent(
      matterId
    )}&include_documents=false`
  );
